export const api = "https://vitaly.care/api";
//export const api = "http://localhost:8080";